import { Factory } from 'miragejs';

export default Factory.extend({
  company_id(i) {
    return `${i + 1}`;
  },
  location_id(j) {
    return `${j + 1}`;
  },
  features() {
    return ['feature1', 'feature2'];
  },
});
